<template>
	<div class="hit-block">
		<div class="hit-block-title">
			<div class="title">忘记密码</div>
		</div>
		<img class="img" src="../assets/4.png" alt="" />
		<p class="p-assist-h">重设密码成功，请重新登录</p>
		<p class="p-assist-c">将为您跳转到登录页...{{count}}s</p>
		<div class="router-block">
			<router-link to="/login">立即跳转</router-link>
		</div>
		<div></div>
	</div>
</template>

<script>
	export default {
		name: "ForgetHit",
		props: {},
		data() {
			return {
				count: 3,
				time: null
			}
		},
		mounted() {
			if (!this.time) {
                
				this.time = setInterval(()=> {
					if (this.count > 0) {
						this.count--
					} else {
						this.count = 0
						this.time = null
						clearInterval(this.timer);
						//直接跳转
						this.$router.push({
							path: '/login',

						});
					}
				}, 3000)
			}
		},
		methods: {

		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	.hit-block {
		width: 658px;
		height: 405px;
		background: #fff;
		margin: 0 auto;
		padding: 20px 20px 40px 22px;

		&-title {
			padding-bottom: 20px;
			border-bottom: 1px solid #dbdbdb;

			.title {
				color: #272f3c;
				font-size: 24px;
				font-weight: bold;
				text-align: left;
			}
		}

		.img {
			margin-top: 40px;
		}

		.p-assist-h {
			color: #333333;
			font-size: 20px;
			margin-top: 26px;
		}

		.p-assist-c {
			color: #9fa5ae;
			font-size: 16px;
			margin-top: 7px;
		}

		.router-block {
			width: 302px;
			height: 45px;
			background: #ffffff;
			border: 1px solid #194abe;
			opacity: 1;
			border-radius: 4px;
			font-size: 16px;
			color: #194abe;
			line-height: 45px;
			text-align: center;
			margin: 0 auto;
			margin-top: 26px;
		}
	}
</style>
